
import { Button, ButtonProps } from "@/components/ui/button";
import { Languages, Pencil } from "lucide-react";
import { useTranslationEdit } from "@/contexts/TranslationEditContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface TranslationEditButtonProps extends Partial<ButtonProps> {
  translationKey: string;
  tooltipText?: string;
}

export function TranslationEditButton({ 
  translationKey, 
  tooltipText,
  size = "sm",
  variant = "ghost",
  className = "h-7 w-7 p-0 ml-1",
  ...props 
}: TranslationEditButtonProps) {
  const { toggleEditMode, isEditMode, canEditTranslations, setEditingKey } = useTranslationEdit();
  
  if (!canEditTranslations) {
    return null;
  }

  const handleClick = () => {
    if (isEditMode) {
      setEditingKey(translationKey);
    } else {
      toggleEditMode();
    }
  };
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={variant}
            size={size}
            onClick={handleClick}
            className={className}
            {...props}
          >
            <Pencil className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText || (isEditMode 
              ? "Edit this translation" 
              : "Enable translation edit mode")}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
